<template>
  <div class="exhibition">
    <div class="container">
      <div class="block1"></div>
      <div class="block2"></div>
      <div class="block3"></div>
      <div
        class="block4"
        onclick="window.location='https://www.csvw.com/csvw-website/news/dz-brand-news.html?newsid=2751'"
      ></div>
      <div
        class="block6"
        onclick="window.location='https://www.csvw.com/csvw-website/news/skoda-brand-news.html?newsid=2747'"
      ></div>
      <div class="block7"></div>
      <div class="block8">
        <div class="block">
          <div class="title">大众品牌车型</div>
          <div class="contain">
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/301.jpg" style="width: 100%;" />
              <div class="text">Viloran 威然</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/302.jpg" style="width: 100%;" />
              <div class="text">Teramont X 途昂X</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/303.jpg" style="width: 100%;" />
              <div class="text">Teramont 途昂</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/304.jpg" style="width: 100%;" />
              <div class="text">Tiguan L 途观L</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/305.jpg" style="width: 100%;" />
              <div class="text">Tharu 途岳</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/306.jpg" style="width: 100%;" />
              <div class="text">T-Cross 途铠</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/307.jpg" style="width: 100%;" />
              <div class="text">PHIDEON 辉昂</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/308.jpg" style="width: 100%;" />
              <div class="text">New Passat 全新一代帕萨特</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/309.jpg" style="width: 100%;" />
              <div class="text">New Lamando 全新凌渡</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/310.jpg" style="width: 100%;" />
              <div class="text">All New Lavida 全新一代朗逸</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/311.jpg" style="width: 100%;" />
              <div class="text">New Santana 新桑塔纳</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/312.jpg" style="width: 100%;" />
              <div class="text">All New Polo Plus 全新一代 Polo Plus</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/313.jpg" style="width: 100%;" />
              <div class="text">Passat PHEV 帕萨特插电式混合动力版</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/314.jpg" style="width: 100%;" />
              <div class="text">Tiguan L PHEV 途观L插电式混合动力版</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/315.jpg" style="width: 100%;" />
              <div class="text">e-Lavida 朗逸纯电</div>
            </div>
            <div class="left">
              <img alt="xxx" src="../../assets/exhibition/imgsMobile/101.png" style="width: 100%;" />
            </div>
            <div class="right">
              <img alt="xxx" src="../../assets/exhibition/imgsMobile/102.png" style="width: 100%;" />
            </div>
          </div>
        </div>
        <div class="block">
          <div class="title">斯柯达品牌车型</div>
          <div class="contain">
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/401.jpg" style="width: 100%;" />
              <div class="text">KODIAQ 柯迪亚克</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/402.jpg" style="width: 100%;" />
              <div class="text">KAROQ 柯珞克智行款</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/403.jpg" style="width: 100%;" />
              <div class="text">KAMIQ 柯米克</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/404.jpg" style="width: 100%;" />
              <div class="text">KODIAQ GT 柯迪亚克GT</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/405.jpg" style="width: 100%;" />
              <div class="text">KAMIQ GT 柯米克GT</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/406.jpg" style="width: 100%;" />
              <div class="text">SUPERB 速派</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/407.jpg" style="width: 100%;" />
              <div class="text">OCTAVIA 明锐智行款</div>
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/408.jpg" style="width: 100%;" />
              <div class="text">RAPID 昕锐</div>
            </div>
          </div>
          <div class="left">
            <img alt="xxx" src="../../assets/exhibition/imgsMobile/101.png" style="width: 100%;" />
          </div>
          <div class="right">
            <img alt="xxx" src="../../assets/exhibition/imgsMobile/102.png" style="width: 100%;" />
          </div>
        </div>
        <div class="block">
          <div class="title">车展花絮</div>
          <div class="contain">
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/501.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/502.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/503.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/504.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/505.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/506.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/507.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/508.jpg" style="width: 100%;" />
            </div>
            <div class="img">
              <img alt="xxx" src="../../assets/exhibition/imgs/509.jpg" style="width: 100%;" />
            </div>
          </div>
          <div class="left2">
            <img alt="xxx" src="../../assets/exhibition/imgsMobile/101.png" style="width: 100%;" />
          </div>
          <div class="right2">
            <img alt="xxx" src="../../assets/exhibition/imgsMobile/102.png" style="width: 100%;" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ExhibitionMobile",
  data() {
    return {
      isPhone: false
    };
  },
  mounted: function() {},
  methods: {}
};
</script>

<style scoped>
.block8 {
  margin-bottom: 30px;
}
.block {
  position: relative;
  width: 100%;
  margin-top: 20px;
}
.contain {
  margin-top: 20px;
}
.block .title {
  font-size: 14px;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  line-height: 14px;
  text-align: center;
}
.block .contain {
  white-space: nowrap; /*文本不会换行，文本会在在同一行上继续*/
  overflow-x: auto; /*可滑动*/
}
/*自定义滚动条的伪对象选择器, CSS 可以隐藏滚动条*/
.block ::-webkit-scrollbar {
  display: none;
}
.block .contain .img {
  width: 60%;
  margin-left: 3%;
  display: inline-block; /*行内块元素*/
}
.block .contain .text {
  margin-top: 10px;
  text-align: center;
  font-size: 12px;
  color: rgba(51, 51, 51, 1);
}
.block .left {
  position: absolute;
  top: 43%;
  left: 5%;
  width: 20px;
  height: 28px;
}
.block .right {
  position: absolute;
  top: 43%;
  right: 5%;
  width: 20px;
  height: 28px;
}
.block .left2 {
  position: absolute;
  top: 50%;
  left: 5%;
  width: 20px;
  height: 28px;
}
.block .right2 {
  position: absolute;
  top: 50%;
  right: 5%;
  width: 20px;
  height: 28px;
}
.block1 {
  background-image: url("../../assets/exhibition/imgsMobile/001.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 108.8%;
}
.block2 {
  background-image: url("../../assets/exhibition/imgsMobile/002.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 73.86666%;
}
.block3 {
  background-image: url("../../assets/exhibition/imgsMobile/003.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 101.86666%;
}
.block4 {
  background-image: url("../../assets/exhibition/imgsMobile/004.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 74.8%;
}
.block5 {
  background-image: url("../../assets/exhibition/imgsMobile/005.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 74.53333%;
}
.block6 {
  background-image: url("../../assets/exhibition/imgsMobile/006.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 76.4%;
}
.block7 {
  background-image: url("../../assets/exhibition/imgsMobile/007.jpg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-bottom: 23.73333%;
}
</style>